<template>
  <template-info :bgImg="bgImg" :title="title">
    <div class="etdb-detail">
      <div class="bold">หักเหมา (60% จากรายได้)</div>
      จากข้อมูลของคุณจะสามารถหักค่าใช้จ่ายได้<br />
      <span class="bold" style="color: #f45a49;">
        {{
          charter.totalExpense
            ? charter.totalExpense.toLocaleString("th-TH")
            : 0
        }}
        บาท
      </span>
    </div>

    <div class="etdb-detail">
      <div class="bold">หักตามจริง</div>
      จากข้อมูลของคุณจะสามารถหักค่าใช้จ่ายได้<br />
      <span class="bold" style="color: #9bcc55;">
        {{ real.totalExpense ? real.totalExpense.toLocaleString("th-TH") : 0 }}
        บาท </span
      ><span v-if="isTaxCharter">*</span>
    </div>

    <div class="etdb-detail">
      แต่จะต้องมีหลักฐานค่าใช้จ่ายด้วย เช่น ใบเสร็จรับเงิน ใบกำกับภาษี บิลเงินสด
      ใบสำคัญรับเงิน
    </div>
    <external-link
      @clickLink="readMoreInfo"
      caption="เอกสารประกอบการหักค่าใช้จ่ายจริง"
      class="link-desktop"
      style="margin-top: 30px;"
      v-if="!isTaxCharter"
    />
    <div v-else>
      *จากการคำนวณภาษี คุณอยู่ในเกณฑ์จ่ายภาษีแบบ
      <span class="red bold">หักภาษีเหมา 0.5% จากรายได้</span>
      ดังนั้นจึงไม่สามารถ หักค่าใช้จ่ายได้
    </div>
  </template-info>
</template>

<script>
import BackgroundImg from "@/assets/images/infos/expense_type_definition.png";
export default {
  name: "ExpenseTypeDefinition",
  components: {},
  computed: {
    isTaxCharter: function () {
      return this.$store.getters["taxInfo/getTaxCharter"];
    },
  },
  data() {
    const { charter, real } = this.$store.getters[
      "taxInfo/taxExpenseDeductionInfo"
    ];
    return {
      charter,
      real,
      bgImg: BackgroundImg,
      title: "หักภาษีแบบเหมากับ\nแบบตามจริงต่างกันอย่างไร",
    };
  },
  methods: {
    readMoreInfo() {
      window.open(
        "https://drive.google.com/file/d/1L--iGdU0wxeWkWiG-pExfF6ZmXtTtufz/view?usp=sharing",
        "_blank"
      );
    },
  },
};
</script>

<style scoped>
.etdb-detail {
  width: 100%;
  color: #393d43;
  margin-bottom: 20px;
  text-align: left;
}
.bold {
  font-weight: bold;
}
.red {
  color: #f45a49;
}
/*size  >768px */
@media only screen and (min-width: 769px) {
  .etdb-detail br {
    display: none;
  }
}
</style>
